import config from '@/config'
import { Method } from '@/utils/request'

const api = {
    get: {
        url: config.apiHost + '/api/users/me',
        type: Method.Get
    },
    valid: {
        url: config.apiHost +'/auth/login',
        type: Method.Post
    }
}

export default api
